import { render, staticRenderFns } from "./UOBInstructionSlip.vue?vue&type=template&id=4f48de2e&"
import script from "./UOBInstructionSlip.vue?vue&type=script&lang=js&"
export * from "./UOBInstructionSlip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports